import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { selectCustomer } from "@/store/slices/adminSlice";

export function CustomerSelector() {
  const dispatch = useAppDispatch();
  const { stats, selectedCustomerId } = useAppSelector((state) => state.admin);

  // Don't show dropdown if there's 0 or 1 customer
  if (!stats?.items || stats.items.length <= 1) {
    return null;
  }

  const handleValueChange = (value: string) => {
    dispatch(selectCustomer(value));
  };

  return (
    <div className="w-[200px]">
      <Select value={selectedCustomerId} onValueChange={handleValueChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select customer" />
        </SelectTrigger>
        <SelectContent>
          {stats.items.map((customer) => (
            <SelectItem key={customer.customer_id} value={customer.customer_id}>
              {customer.customer_name}
            </SelectItem>
          ))}
          <div className="h-px bg-muted my-1" />
          <SelectItem value="total">Total</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
